export default __webpack_public_path__ + "static/media/starbucks.1c3289fe.png";